import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reduxForm, reset, initialize } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';

import * as ProductActions from 'redux/modules/products';
import productForm from './product.json';
import {generateFicheInputs} from 'utils/generateFicheInputs.js';
import { routeActions } from 'react-router-redux';

const actionModules = { ProductActions };


import _ from 'underscore';

import i18next from 'i18next';

import validate from './productValidation';
import {analyseState, getStateSummary} from 'utils/analyseState';

import SiteStatePanel from './SiteStatePanel';
import ModifyPhoneNumber from './ModifyPhoneNumber';
import ModifyIDPTU from './ModifyIDPTU';
import ResetSerialNumber from './ResetSerialNumber';
import AdminChangeGSM from './AdminChangeGSM';
import RemoteTestLift from './RemoteTestLift';
import MobileProductHub from './MobileProductHub';

import sitesForm from './sites.json';

import {Button, Row, Tabs, Tab, Col, Alert, Tooltip, OverlayTrigger, Table, Popover} from 'react-bootstrap';
import {DeleteButton} from 'components';

import Select from 'react-select';
//import 'react-select/dist/react-select.css';
import 'vis/dist/vis-timeline-graph2d.min.css';

import moment from 'moment'

var Datetime = require('react-datetime');
import ReactModal from 'react-modal';

import vis from 'vis';

import { push } from 'react-router-redux'
import { resetFilter } from 'redux/modules/supervision';

import LineChart from './charts/LineChart';
import TimelineChart from './charts/TimelineChart';
import PieChart from './charts/PieChart';

import GaugeChart from './charts/GaugeChart';

import { slide as Menu } from 'react-burger-menu'

var fields = ['groups', 'users'];

fields.push('product.id');
fields.push('product.t_id');
fields.push('product.s_id');


_.each(sitesForm, (group, key)=>{
  if( key == 'Configuration du FTP prestataire' ) {
    _.each(group.inputs, (input)=>{
      fields.push('site.'+input.name)
    })
  }
})


require('./Product.css');

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

var modalStyles = {
  overlay : {
    position          : 'fixed',
    top               : 0, 
    left              : 0,
    right             : 0,
    bottom            : 0,
    backgroundColor   : 'rgba(255, 255, 255, 0.75)', 
    zIndex:1000000
  },
  content : {
     top                   : '50%',
     left                  : '50%',
     right                 : 'auto',
     bottom                : 'auto',
     marginRight           : '-50%',
     transform             : 'translate(-50%, -50%)',
     //width                 : '400px',
     overflow              :'visible'

  }
}


for(var group in productForm ) {
  var group_obj = productForm[group];
  for(var el in group_obj ) {
    fields.push('product.'+group_obj[el].name)
  }
}

import { translate } from 'react-i18next';

@translate(['common'])

@reduxForm({
  form: 'productForm',
  fields: fields,
  //asyncValidate,
  //asyncBlurFields:['sites.identification_GSM', 'products[].identification_ID'],
  overwriteOnInitialValuesChange:true, 
  validate,
  destroyOnUnmount: true
})

@connect(
  state => ({
    created: state.products.created,
    error: state.products.error,
    success: state.products.success,
    product:state.products.product,
    routeChanges:state.routing.location,
    user:state.auth.user,
    groups: state.groups.data,
    pit_loading: state.products.pit_loading,
    pit_success: state.products.pit_success,
    pit_error: state.products.pit_error,
    used_mods:state.products.used_mods,
    site_state:state.products.site_state,
    mcpCalled:state.products.mcpCalled,
    id_dup:state.products.id_dup,
    check_id_dups_loading:state.products.check_id_dups_loading, 
    levels_counts_loading:state.products.levels_counts_loading, 
    levels_counts:state.products.levels_counts,
    pit_id:state.products.pit_id,
    forceActivationSuccess:state.products.forceActivationSuccess,
    forceActivationError:state.products.forceActivationError,
    idptuError:state.products.idptuError,
    phoneError:state.products.phoneError,
    created:state.products.created,
    sort_counts_begin_date:state.products.sort_counts_begin_date,
    sort_counts_end_date:state.products.sort_counts_end_date,
    extra_tabs:state.products.extra_tabs, 
    from:state.products.from,
    loading:state.products.loading,
    smsActions:state.products.smsActions,
    id_dup_text:state.products.id_dup_text,
    check_id_dups_loading:state.supervision.check_id_dups_loading,
    selectedTab:state.products.selectedTab,
    basicTabs:state.products.basicTabs    
  }), 
  dispatch=>bindActionCreators({...ProductActions, ...routeActions}, dispatch)
)
export default class ProductForm extends Component {
  
  constructor(props){

    const {t} = props
    
    super(props);
    
    
    this.wasDirty = {
        identification_GSM : false,
        identification_ID  : false
    }

    
    var timelineGroups, timelineGroupsDataSet, timelineItems, timelineOptions, 
      barGraphOptions, barGraphItems, barGraphGroups,
      cyclicalGraphOptions, cyclicalGraphItems, cyclicalGraphGroups,
      cyclicalTMGraphOptions, cyclicalTMGraphItems, cyclicalTMGraphGroups
    
    
    
    
    /*
    var nb_pannes = _.where(this.props.product.timeline_rows, {type:'panne'}).length
    var nb_travaux = _.where(this.props.product.timeline_rows, {type:'travaux'}).length
    var nb_indispo = _.where(this.props.product.timeline_rows, {type:'indisponible'}).length
    var nb_usager = _.where(this.props.product.timeline_rows, {type:'usager'}).length 
    var nb_tech = _.where(this.props.product.timeline_rows, {type:'technicien'}).length */
    
    if( this.props.action == 'update' ) {

      var nb_pannes  =  this.props.product.totaux.pannes.total
      var nb_travaux =  this.props.product.totaux.travaux.total
      var nb_indispo =  this.props.product.totaux.indispos.total
      var nb_usager  =  this.props.product.totaux.usagers.total
      var nb_tech    =  this.props.product.totaux.techniciens.total

      cyclicalTMGraphOptions = {  
        width: '100%', 
        type: 'range',  
        format: {
          minorLabels: {
            minute: 'h:mma',
            hour: 'ha'
          }
        },
        locale: 'fr',
        orientation:'both',
        stack:false   
      }
                  
      cyclicalGraphOptions = {
        defaultGroup: 'main',
        legend: {left:{position:"bottom-left"}},
        start: this.props.product.activations.length > 0 ? new Date(this.props.product.activations[0].date_reference * 1000) : new Date(),
        end: new Date(), 
      };
            
      var codes = this.props.product.codes;
            
      cyclicalGraphGroups =  [{ 
        id: 'main',
        content: 'main',
        style:"background:#fdf6bf",
        visible:true,
        options: {
          drawPoints: {
            style: 'circle' // square, circle
          },
          
          interpolation: false, 
          shaded: {
              orientation: 'top' // top, bottom
          }
        }
      }
      ]
      
      cyclicalGraphGroups = new vis.DataSet(cyclicalGraphGroups)
         
      var y = 0;

      var barGraphItems3 = []

      var etages = []

      _.each(this.props.product.supEntries, (e)=>{

        barGraphItems3.push({
          date:e.date_reference,//moment(e.date_reference *1000),
          //mdate:moment(e.date_reference *1000),
          deplacements:parseInt(e.move_count),
          ouvertures:parseInt(e.openings),
          ..._.omit(e, ['date_reference', 'move_count', 'openings'])
        })
       
      })      
      
      var z = 0;
      
      cyclicalGraphItems = []
      
      _.each(this.props.product.cyclicalEntries, (e)=>{
        z++
        var y = e.call_type == '04' ? 10 : 5
        cyclicalGraphItems.push({id:z, x:moment(e.date_reference *1000).format('YYYY-MM-DD'), y, label:{content:String('code : '+e.call_type)}, group:'main'})
        
      })            
      
      cyclicalGraphItems = new vis.DataSet(cyclicalGraphItems)      

      var timelineItems2 = generateTimelineItems2(this.props.product.timeline_rows, codes, this.props.user, props.t)
      var cyclicalTMGraphItems = generateCyclicalTimelineItems(this.props.product.cyclicalEntries, null, this.props.user)
      
      cyclicalTMGraphGroups = new vis.DataSet([
        {
          id: 'main',
          content: 'main',
          style:"background:#ffafbc",
          visible:true
        }
      ])
    
    }
    
    var is_pit, is_master;
    var idff = this.props.product.identification_fosse
    
    if( idff > 0 ) {
      is_pit = true;
      is_master = false;
    } else if( idff == -1 ) {
      is_pit = false;
      is_master = true;
    } else if (idff == 0 || idff == null) {
      is_pit = false;
      is_master = false;
    }

    this.state = {
      key: 1,
      reloadKey: 0,
      showModal: false,
      closeCallBack:false,
      pit_loaded:false, 
      travauxVisible:true,
      pannesVisible:true,
      indisponibleVisible:true,
      cyclicalGraphItems,
      is_master, 
      is_pit,
      stack:false,
      gsm_error:false,
      cyclicalGraphGroups,
      cyclicalGraphOptions,
      cyclicalTMGraphOptions, cyclicalTMGraphItems, cyclicalTMGraphGroups,
      barGraphItems3,
      timelineItems2,
      filterByDate:'',
      mobileFull:false,
      //barGraphItems3:[]
    };

    if( props.action == 'update') {

      var first_activation_begin_date = props.product.activations.length > 0 ? new Date(props.product.activations[0].date_reference * 1000) : new Date()

      var begin_date =  new Date()
      begin_date.setMonth(0)
      begin_date.setDate(1)
      begin_date.setHours(0)
      begin_date.setMinutes(1)

      if(first_activation_begin_date.getFullYear()==begin_date.getFullYear()){
        begin_date = first_activation_begin_date
      }

      /*
      if( props.product.activations.length > 0 ) {

        var begin_date = new Date(props.product.activations[0].date_reference * 1000)
        begin_date.setHours(23)
        begin_date.setMinutes(59)

      } else {
        var begin_date =  new Date()
        begin_date.setMonth(0)
        begin_date.setDate(1)
        begin_date.setHours(0)
        begin_date.setMinutes(1)

        
      }*/


      
      var end_date  = new Date();
      /*
      begin_date.setMonth(0)

      begin_date.setDate(1)
  
      begin_date.setHours(0)
      begin_date.setMinutes(1)
          
   
      end_date.setHours(23) 
      end_date.setMinutes(59)*/

      this.state = {
        ...this.state,
        begin_date,
        end_date,
        first_activation_begin_date,
        begin_year:first_activation_begin_date.getFullYear(),
        end_year:end_date.getFullYear()
      }

    }
    
    this.handleSelect = this.handleSelect.bind(this);
    this.openMobileSection = this.openMobileSection.bind(this);
    this.setMobileFull = this.setMobileFull.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.reloadForm = this.reloadForm.bind(this);
    
    this.chk_pannes_change = this.chk_pannes_change.bind(this);
    this.chk_travaux_change = this.chk_travaux_change.bind(this);
    this.chk_indisponible_change = this.chk_indisponible_change.bind(this);
    this.chk_stack_change = this.chk_stack_change.bind(this);
    
    this.triggerError = this.triggerError.bind(this);
    
  }

  filterFunc(fromStart=false)  {

    var self = this;

    var begin_date, end_date, begin_date_u, end_date_u, begin_date_u2, end_date_u2 = null


    if( fromStart ) {

      begin_date = moment(this.state.first_activation_begin_date)
      end_date   = moment()
      

      begin_date_u = begin_date.format('YYYY-MM-DD HH:mm:ss')
      end_date_u   = end_date.format('YYYY-MM-DD HH:mm:ss')

      begin_date_u2 = begin_date.unix()
      end_date_u2   = end_date.unix()

    } else {

      begin_date = this.refs.begin_date_t.state.selectedDate;
      end_date   = this.refs.end_date_t.state.selectedDate;
          
      begin_date_u = this.refs.begin_date_t.state.selectedDate.format('YYYY-MM-DD HH:mm:ss')
      end_date_u   = this.refs.end_date_t.state.selectedDate.format('YYYY-MM-DD HH:mm:ss')
  
      begin_date_u2 = this.refs.begin_date_t.state.selectedDate.unix()
    }
    
    end_date_u2   = this.refs.end_date_t.state.selectedDate.unix()

    const {urlParams} = this.props;
        
    this.props.loadProduct(urlParams.productID, urlParams, {begin_date:begin_date_u, end_date:end_date_u} ).then(()=>{
      this.props.sortCounts(begin_date_u2, end_date_u2, urlParams).then(()=>{
        this.setState({begin_date:begin_date.toDate(), end_date:end_date.toDate()})
      })
    })

  }
  
  
  triggerError(error, type){
    
    if( type == 'phone' ) {
      this.props.fields.product.identification_GSM.onChange(this.props.product.identification_GSM)
    }
    
    if( type == 'idptu' ) {
      this.props.fields.product.identification_ID.onChange(this.props.product.identification_ID) 
    }
    
    
  }
  
  chk_pannes_change(e){
    
    var groups = this.state.timelineGroups         
    groups[0].visible = this.refs.chk_pannes.checked
    
    this.setState({pannesVisible:this.refs.chk_pannes.checked})
    this.timeline.setGroups(new vis.DataSet(groups))
  }
  
  chk_travaux_change(e){
    var groups = this.state.timelineGroups
    groups[1].visible = this.refs.chk_travaux.checked
    this.setState({travauxVisible:this.refs.chk_travaux.checked})
    this.timeline.setGroups(new vis.DataSet(groups))
  }
 
  chk_indisponible_change(e){
    var groups = this.state.timelineGroups
    groups[2].visible = this.refs.chk_indisponible.checked
    
    this.setState({indisponibleVisible:this.refs.chk_indisponible.checked})
    
    this.timeline.setGroups(new vis.DataSet(groups))
  }
  
  chk_stack_change(e){ 
    
    this.setState({stack:this.refs.chk_stack.checked}, ()=>{ 
      this.timeline.setOptions({...this.state.timelineOptions, stack:this.state.stack}) 
       
      if( this.refs.chk_stack.checked ) {
        this.timeline.zoomIn( 0.1 )
      } else {
        this.timeline.zoomOut( 0.1 )
      }           
    })
    
  }
  
  
  handleOpenModal (modalBody, closeCallback) {
    this.setState({ showModal: true, modalBody, closeCallback});
  }
   
  handleCloseModal () {
    var self = this;
   
    this.setState({ showModal: false }, ()=>{ 
      self.reloadForm();
    });
    
  } 
  
  
   
  componentDidMount(){ 
    
    // S'abonner aux updates WebSocket pour ce site
    // En admin: urlParams.cid, en client: user.name, en user: user.client (le login du client parent)
    var wsClient = (this.props.urlParams && this.props.urlParams.cid) 
      || (this.props.user && this.props.user.client) 
      || (this.props.user && this.props.user.name);
    if (this.props.product && this.props.product.s_id && wsClient) {
      global.subscribeSite(this.props.product.s_id, wsClient);
    }
    
    // Restaurer l'onglet sélectionné après F5
    if (this.props.product && typeof sessionStorage !== 'undefined') {
      var savedTab = sessionStorage.getItem('selectedTab_' + this.props.product.id);
      if (savedTab) {
        var tabKey = parseInt(savedTab);
        this.setState({ key: tabKey });
        this.props.dispatch(ProductActions.storeSelectedTab(tabKey));
      }
    }

    // Arrivée directe sur Bilan / TestLift (depuis la liste) : pas de passage par la vue simplifiée
    if (this.props.selectedTab == 2000 || this.props.selectedTab == 2001) {
      this.setState({ mobileFull: true });
    }
    
    if( this.props.action == 'update' ) {
      
      this.props.dispatch(
          ProductActions.getUsedMods(
            {
              params:this.props.urlParams,
              siteID:this.props.product.s_id,
              identification_GSM:this.props.product.identification_GSM,
              identificationType:this.props.product.identification_type,
              p_id:this.props.product.id,FFNUM_MODE:this.props.product.FFNUM_MODE,
              gsm_dirty:this.props.fields.product.identification_GSM.dirty 
            }
          )
      ).then(()=>this.setState({gsm_error:false}), (e)=>this.setState({'gsm_error': (e && e.error) ? e.error : (typeof e === 'string' ? e : 'Erreur serveur')}))
      
      
      
      /*
      if( 'traffic' in this.props.routeChanges.query || 'dispo' in this.props.routeChanges.query){
        
        this.props.dispatch(ProductActions.expandTabs(2000, true), ()=>this.props.dispatch(ProductActions.expandBasicTabs(2000, true)))

          
      }*/
       
      
       
     
    }


    
  }
  
  componentDidUpdate(prevProps, prevState){
    
    
    if( JSON.stringify(prevProps.used_mods) != JSON.stringify(this.props.used_mods) ) {
      
      var used_mod_nums_master = this.props.used_mods.map((m)=>{
        return m.identification_NUM_MOD; 
      }); 
      
      var choices = [];
                
      for(var i = 1; i <= 8; i++){
        if( _.indexOf(used_mod_nums_master, i) == -1 ) {
          choices.push(i)
        } 
      } 
      
      var update = true
      
      
   
      if( this.props.action == 'update' ) {
        
        if( (this.props.fields.product.identification_NUM_MOD.dirty == true)  && 
            used_mod_nums_master.indexOf(parseInt(this.props.values.identification_NUM_MOD)).length > -1
            || this.props.fields.product.identification_GSM.dirty
        ) { 
          update = true;
        }
 
      }

      
      if( this.props.action == 'create') {
        if(
            this.props.fields.product.identification_NUM_MOD.dirty == true || 
            this.props.values.productdentification_NUM_MOD in used_mod_nums_master
        ) {
          update = true; 
        }
      }
    
      

      
      
      if( update ) { 
        
        this.props.fields.product.identification_NUM_MOD.onChange(choices[0]) 
      } 
      
    }

    if( this.props.extra_tabs && this.props.action == 'update' ) {
      
      if( this.state.is_pit == false ) {
        
        var cyclical_container = document.getElementById('cyclical_graph');
        
        if( this.props.user.role == 'admin' && ! this.cyclical_graph && cyclical_container) {

          //var cyclical_graph = new vis.Graph2d(cyclical_container, this.state.cyclicalGraphItems, this.state.cyclicalGraphGroups, this.state.cyclicalGraphOptions);
          //this.cyclical_graph = cyclical_graph
        }
         
      }
      
    } else {

      this.cyclical_graph = null
       
    }

    if( JSON.stringify(prevProps.product.supEntries) != JSON.stringify(this.props.product.supEntries) ) {

    var barGraphItems3 = []

    _.each(this.props.product.supEntries, (e)=>{

      barGraphItems3.push({
        date:e.date_reference,//moment(e.date_reference *1000),
        //mdate:moment(e.date_reference *1000),
        deplacements:parseInt(e.move_count),
        ouvertures:parseInt(e.openings),

        ..._.omit(e, ['date_reference', 'move_count', 'openings'])

        
      })
      
    })

    this.setState({barGraphItems3})
  }
    
    
    
  }
   
  
  reloadForm(){
    var self = this;
    
    this.props.dispatch(
        ProductActions.loadProduct(this.props.urlParams.productID, this.props.urlParams))
          .then((result)=>{
            self.props.resetFormCs()
            self.setState({gsm_error:false, reloadKey: self.state.reloadKey + 1})
            
            // Réinitialiser le formulaire Redux Form avec les nouvelles données
            if (result && result.product) {
              var product = result.product;
              var site = result.site || product;
              var groups_ids = product.groups ? product.groups.map((g) => g.id) : [];
              var users = product.users ? product.users.map((u) => ({ label: u.login, value: u.id })) : [];
              
              self.props.dispatch(initialize('productForm', {
                product: product,
                groups: groups_ids,
                site: site,
                users: users
              }));
            }
          })
          

  } 
  
  
  handleSelect(key) {

    // Sauvegarder l'onglet sélectionné dans sessionStorage pour le restaurer après F5
    var productId = this.props.product ? this.props.product.id : null;
    if (productId && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('selectedTab_' + productId, key);
    }
    
    if( key == 4 ) {
      this.setState({key:key, pit_loaded:true});
      this.props.dispatch(ProductActions.storeSelectedTab(key));

    } else if( key == 888 ) {
      this.props.dispatch(ProductActions.expandBasicTabs(1, false));
    } else if( key == 777 ) {
      var k ;
      if( this.state.key < 2000 ) {
        k = this.state.key;
      } else { 
        k = 1
      }
     
      this.props.dispatch(ProductActions.expandTabs(key, false));
      
      this.setState({key:k}, ()=>{
        //this.props.dispatch(ProductActions.expandTabs(key));
      });

      this.props.dispatch(ProductActions.storeSelectedTab(k));


    } else {
      this.setState({key});
      this.props.dispatch(ProductActions.storeSelectedTab(key));

      if(key == 2000) {
        this.props.dispatch(ProductActions.expandBasicTabs(key, false));
      }
    }
    
  }
  
  setMobileFull(mobileFull) {
    this.setState({ mobileFull });
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  // Ouvre une section (onglet) de la version complète depuis la vue simplifiée mobile
  openMobileSection(key) {
    if (key == 2000) {
      if (this.props.basicTabs) {
        this.handleSelect(2000);
      } else {
        this.props.dispatch(ProductActions.storeSelectedTab(2000));
      }
    } else {
      if (!this.props.basicTabs) {
        this.props.dispatch(ProductActions.expandBasicTabs(key, true));
      }
      this.handleSelect(key);
    }
    this.setMobileFull(true);
  }

  componentWillUnmount(){
    // Se désabonner des updates WebSocket pour ce site
    var wsClient = (this.props.urlParams && this.props.urlParams.cid) 
      || (this.props.user && this.props.user.client) 
      || (this.props.user && this.props.user.name);
    if (this.props.product && this.props.product.s_id && wsClient) {
      global.unsubscribeSite(this.props.product.s_id, wsClient);
    }
    this.props.resetFormCs();
    //this.props.dispatch(ProductActions.expandTabs())
  }
  
  render() {
    var self = this;
    const {
      asyncValidating,
      editStop,
      fields,
      formKey,
      handleSubmit,
      invalid,
      resetForm,
      createProduct,
      values,
      created,
      pristine,
      save,
      error, 
      success,
      urlParams,
      user, product, groups, 
      loading, used_mods, 
      mcpCalled, id_dup,
      check_id_dups_loading, levels_counts, idptuError, phoneError,
      sort_counts_begin_date, sort_counts_end_date, 
      extra_tabs, from, users, id_dup_text, basicTabs, t
    } = this.props;

    var {
      begin_date, 
      end_date,
      first_activation_begin_date,
      begin_year,
      end_year
    } = this.state;

        
    var mandatory_input_changed = [];

    //var lineChartData = this.state.barGraphItems3 ? this.state.barGraphItems3.filter((r)=>r.date >= this.state.begin_date.getTime()/1000  &&  r.date < this.state.end_date.getTime()/1000 ) : []
    var lineChartData = this.state.barGraphItems3 || []

    var disableAsyncUpdate = (user.role.indexOf('user') > -1 && user.super_user == 0)

    var id_dup_alert = (this.props.id_dup == true && fields.product.identification_ID.dirty) ? 
       <Alert bsStyle="danger">
         <i className="fa fa-warning" aria-hidden="true"/> &nbsp;
         {id_dup_text}
       </Alert> : ''
     
              
    var used_mods2 = used_mods.filter((m)=>
      {
        if(!this.props.product.FFNUM_MODE) {
           return true;
        } else {
          return parseInt(this.props.product.FFNUM_MODE) != parseInt(m.identification_NUM_MOD)
        }
      })
           
     var num_mod_alert = (fields.product.identification_GSM.dirty && used_mods2.length > 0 ) ? 
       <Alert bsStyle="warning">
         <div>
             <i className="fa fa-warning" aria-hidden="true"/> &nbsp;
              
              <b>{t("productForm.phone_changed")} :</b>
              <br/> 
              {t("productForm.occupied_phones", {phone:fields.product.identification_GSM.value})} : 
              {used_mods2.map((m)=>m.identification_NUM_MOD).join(', ')}, {t("productForm.forbidden_numbers")} 
           </div>
         </Alert> : ''
         
    var self = this;

    var ProductformGroups = [];
    var address = fields.product.localisation_adresse.value;
    
    var state = this.props.action == 'update' ? this.props.pristineValues.site.site_etat:0;
    var sFields = fields.site;

    const tooltipAide = (
      <Tooltip id="tooltipAide"><strong>{t("main.help")}</strong></Tooltip>
    );

    const tooltipEditPr = (
      <Tooltip id="tooltipEditPr"><strong>{t("main.edit_product")}</strong></Tooltip>
    );
    
    const tooltipSup = (
      <Tooltip id="tooltipSup"><strong>{t("productForm.product_supervision")}</strong></Tooltip>
    );
    
    const tooltip1 = (
      <Tooltip id="tooltip"><strong>{t("productForm.num_mod_1")}</strong></Tooltip>
    );
    
    const tooltip2 = (
        <Tooltip id="tooltip"><strong>{t("productForm.num_mod_not_1")}</strong></Tooltip>
      );  
      
    var is_master_product = false;
    var is_slave = false;
    
    var editProductPath1;
    var addGrpPath;
    var fichesListPath;

    
    if( user.role == 'admin' ) {
      var cid = 'cid' in urlParams ? urlParams.cid : urlParams.id

      editProductPath1 = '/'+urlParams.role+'/'+cid+'/product/'+self.props.product.masterId+'/edit'
      addGrpPath =  '/'+urlParams.role+'/groups'+'/'+cid+'/create';
      fichesListPath = '/'+urlParams.role+'/products/'+cid;

    } else if( user.role.indexOf('client') > -1 || user.role == 'demo' ) {
      editProductPath1 = '/client/product/'+self.props.product.masterId+'/edit'
      addGrpPath = "/client/addGroup";
      fichesListPath = "/client/products";

    } else if( user.role.indexOf('user') > -1 ) {
      editProductPath1 = '/user/product/'+self.props.product.masterId+'/edit'
      addGrpPath = '/user/groups/'+user.c_id+'/create';
      fichesListPath = "/user/fiches";  
    } 
    
    
      
    if( self.props.action == 'update' ) {
      

      if( this.props.product.identification_NUM_MOD == 1 ) {
        
        is_master_product = (
          <Row>
            <div className="col-xs-2">
            <Alert bsStyle="info">
              <strong>
                {t("productForm.master_sheet")}
                &nbsp;
              </strong>
              <OverlayTrigger placement="right" overlay={tooltip1}>
                <i className="fa fa-info-circle" aria-hidden="true"></i>
              </OverlayTrigger>
            </Alert>
          </div>
        </Row>)
        
      } else {
        
        /*var editProductPath1 = user.role == 'admin' ?
            '/'+urlParams.role+'/'+urlParams.cid+'/product/'+self.props.product.masterId+'/edit' :
            '/client/product/'+self.props.product.masterId+'/edit';*/
      
        
          
        var masterLink = product.masterId != null ? 
          <LinkContainer to={editProductPath1}>
            <Button bsStyle="primary" bsSize="small">
              {/*<i className="fa fa-pencil" aria-hidden="true"></i>*/} 
              <span> {t("productForm.the_master_sheet")}</span>
            </Button>
          </LinkContainer>
          
          :
            
          <div>
            {t("productForm.no_master_sheet")}
          </div>
            
      
        is_slave =  
          <Row>
            <div className={user.role != "user" ? "col-xs-12 col-md-5" : "col-xs-12 col-md-5"}> 
              <Alert bsStyle="info">
                <div>
                  <strong>{t("productForm.slave_sheet")}&nbsp;</strong>
                  <OverlayTrigger placement="right" overlay={tooltip2}>
                    <i className="fa fa-info-circle" aria-hidden="true"></i>
                  </OverlayTrigger> 

                  {(user.role != 'user' || user.super_user == 1) &&
                    <div>
                      {t("productForm.sync_only_on_master")}&nbsp;
                      {masterLink}
                    </div>
                
                }
                </div>
              </Alert>
                
            </div>
          </Row>
      }      
      
    }    
         
    var tabs = [];    
    
    if( fields.product.identification_GSM.dirty == true && is_master) {
      mandatory_input_changed.push('identification_GSM')
    }
    
    /*if( fields.product.identification_NUM_MOD.dirty == true ) {
      mandatory_input_changed.push('identification_NUM_MOD')
    }*/
    
    if( fields.product.identification_ID.dirty == true  && is_master) {
      mandatory_input_changed.push('identification_ID')
    }    
    
    /*if( this.props.action == "update" && fields.product.identification_GSM.dirty == true && is_master_product != false ) {
      var cascade_num_change = 
        <Col xs={5}> 
          <Alert bsStyle="info">
           <i className="fa fa-info" aria-hidden="true"/> &nbsp;
           Vous allez modifier le numéro d'une fiche maître, tous les numéros de ses esclaves seront mis à jours également
          </Alert>
        </Col>
      
    } else {
      var cascade_num_change = <span/>
    }*/          
    
    var SitesformGroups = [];
    
    _.each(sitesForm, (group, key)=>{
      
      if( key == 'Configuration du FTP prestataire' ) {
        var sitesInputs = [];
        _.each(group.inputs, (input)=>{
          var prop = fields['site'][input.name];
          var disabled = (user.role.indexOf('user') > -1 && user.super_user == 0)? true : false;
          sitesInputs.push( generateFicheInputs(prop, input, disabled || input.readOnly,  false, false, null, true, false, false, t) );
        })
        SitesformGroups.push(
          <Col md={8}> 
            {sitesInputs}
          </Col>
          
        );
      }
    })
    
    /*
    if (typeof address === 'object' && address != null ) {
      var city = address.gmaps['address_components'].filter(function(addr){
         return (addr.types[0]=='locality')?1:(addr.types[0]=='administrative_area_level_1')?1:0;
      });
         
      var zip_code = address.gmaps['address_components'].filter(function(addr){
        return (addr.types[0]=='postal_code')?1:0;
      });
      
    }*/
    
    
    var className = "col-xs-6";
    
    var btnFosse = <span/>;
    
    if( self.props.action == 'update') {
    
      var idff = fields.product['identification_fosse'].value;
      //var is_pit = fields.product['is_pit'].value;
      
      var is_pit, is_master;
      
      if( idff > 0 ) {
        is_pit = true;
        is_master = false;
      } else if( idff == -1 ) {
        is_pit = false;
        is_master = true;
      } else if (idff == 0 || idff == null) {
        is_pit = false;
        is_master = false;
      }
      /*
      if(product.identification_NUM_MOD == 1 ) {
        is_master = true
      } else if( product.identification_NUM_MOD > 1 ){
        is_master = false
      }*/
      

      var successTitle = t("productForm.sheet_updated_success");
      
      if( is_pit == true ) {
        successTitle = t("productForm.pit_updated_success")
      } else if( is_master == true ) {
        successTitle = t("productForm.master_sheet_updated")
      } else if( is_slave != false ) {
        successTitle = t("productForm.slave_sheet_updated")
      }
      
      /*if( loading ) {
        var successMessage = "";
      }*/

      
    
             

      /*if( self.props.pit_success == true ){
        btnFosse = <Button bsStyle="success">PIT rajouté</Button>
      }
      
      if( self.props.pit_error == true ){
        btnFosse = <Button bsStyle="danger">Erreur</Button>
      }
      
      */
  
      
      var select_opts = [];
      
      var used_mod_nums_master = used_mods.map((m)=>{
        
        
        return m.identification_NUM_MOD; 
        /*
        if( product.s_id == null ) {
          return m.identification_NUM_MOD;
        } else {
          if( product.identification_NUM_MOD != m.identification_NUM_MOD  ){
            return m.identification_NUM_MOD;
          }
        }*/

      });
      

      var used_mod_nums_pit = used_mods.map((m)=>{
        return m.identification_NUM_MOD;
      });
      used_mod_nums_pit.push(parseInt(values.product.identification_NUM_MOD))
      
      for(var i = 2; i <= 8; i++){
        if( _.indexOf(used_mod_nums_pit, i) == -1 ) {
          select_opts.push(<option value={i}>{i}</option>)
        } 
      }
      
      var pristineNM = self.props.pristineValues.product.identification_NUM_MOD;
      


      var num_mod_select = 
        (<span> <b>{t("productForm.numero_module")} &nbsp;</b>
          <select id="num_mod">
            {select_opts}
          </select>
          
          {/*&nbsp;ID PTU : <input type="text" id="pit_id_ptu"/>*/}
          
        </span>
        )
      
      /*var editProductPath = user.role == 'admin' ?
          '/'+urlParams.role+'/'+urlParams.cid+'/product/'+self.props.product.FF+'/edit' :
          '/client/product/'+self.props.product.FF+'/edit';*/
          
      var editProductPath;
      
      if( user.role == 'admin' ) {
        editProductPath = '/'+urlParams.role+'/'+urlParams.cid+'/product/'+self.props.product.FF+'/edit'
      } else if( user.role.indexOf('client') > -1 || user.role == 'demo' ) { 
        editProductPath = '/client/product/'+self.props.product.FF+'/edit'
      } else {
        editProductPath = '/user/product/'+self.props.product.FF+'/edit'
      }

      var supPath;
           
      if( user.role == 'admin' ) {
        supPath = '/'+urlParams.role+'/supervision/'+urlParams.cid+'/?id='+self.props.product.identification_ID+'&pid='+self.props.product.id
      } else if( user.role.indexOf('client') > -1 || user.role == 'demo' ) { 
        supPath = '/client/supervision/?id='+self.props.product.identification_ID+'&pid='+self.props.product.id
      } else {
        supPath = '/user/supervision/?id='+self.props.product.identification_ID+'&pid='+self.props.product.id
      }

      
      
      
      
      if( self.props.pit_loading == true ) {
        btnFosse = <Button bsStyle="info">
          {t("main.loading")} <i className="fa fa-spinner fa-pulse fa-fw"></i>
        </Button>
      } else {
      
        if(  is_pit == false  ) {
          //Si le produit n'a pas de PIT
          if( is_master == false ) {
            
            if( (user.role != 'user' || user.super_user == 1) ) {
             
              btnFosse = <div><Button bsStyle="primary" onClick={()=>{
                var e = document.getElementById('num_mod');
                //var pit_id_ptu = document.getElementById('pit_id_ptu').value;
                var value = e.options[e.selectedIndex].value;
                values.product['identification_NUM_MOD'] = value;
                //values.product['identification_ID'] = pit_id_ptu;
                values.product['addr_id'] = self.props.product.addr_id;
                self.props.dispatch(ProductActions.handlePit(urlParams, values, fields, false)).then(()=>{
                                    
                  /*var editProductPath = user.role == 'admin' ?
                      '/'+urlParams.role+'/'+urlParams.cid+'/product/'+self.props.pit_id+'/edit' :
                      '/client/product/'+self.props.pit_id+'/edit';
                      
                  self.props.push(editProductPath);*/
                  
                  //self.reloadForm() 
                  
                  self.props.dispatch(
                      ProductActions.getUsedMods(
                        {
                          params:self.props.urlParams, 
                          siteID:values.product.s_id,
                          identification_GSM:values.product['identification_GSM'],
                          identificationType:values.product.identification_type,
                          p_id:this.props.product.id, FFNUM_MODE:this.props.product.FFNUM_MODE,
                          gsm_dirty:this.props.fields.product.identification_GSM.dirty
                        
                        }
                      )
                  ).then(()=>this.setState({gsm_error:false}), (e)=>this.setState({'gsm_error': (e && e.error) ? e.error : (typeof e === 'string' ? e : 'Erreur serveur')}))
                })
              }}><i className="fa fa-plus-circle" aria-hidden="true"></i>{t("productForm.add_a_pit")} </Button> {num_mod_select} <br/></div>
              
            } else {
              btnFosse = <span>{t("productForm.no_pit")}</span>
            }
            
          } else {
            
            btnFosse = 
              <div>
                &nbsp;&nbsp;<i className="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
                <b>
                  {t("productForm.sheet_has_pit")} &nbsp;
                  
                  <span style={{color:'red'}}>
                    {t("productForm.on_the_module")} {this.props.product.FFNUM_MODE}
                  </span>  
                </b>
                
                <br/>
                {(user.role != 'user' || user.super_user == 1) &&
                
                <div style={{display:'block'}}>
                  {/*(this.state.key == 4 || this.state.pit_loaded == true) &&
                  <div style={{'overflow':'hidden', height:'270px' }}>
                    
                    <iFrame  scrolling="no" style={{border:'0', 
                      width:'86%', height:"576px", top:'-177px', 
                      position:'relative', 'overflow': 'hidden'}} src={editProductPath+'#tabContainer'}/>
                    
                  </div>
                  */}

                  <div>
                    <LinkContainer to={editProductPath}>
                      <Button bsStyle="primary" bsSize="small">
                        <i className="fa fa-pencil" aria-hidden="true"></i> {t("main.edit")}
                      </Button>
                    </LinkContainer>
                    
                    {/*t("main.are_you_sure")*/}
                    &nbsp;
                    <DeleteButton size="sm" ctext={t("main.are_you_sure")} text={t("main.delete")}
                      callback={()=>{
                        self.props.dispatch(ProductActions.handlePit(urlParams, values, fields, true)).then(()=>{
                          
                          self.props.dispatch(
                              ProductActions.getUsedMods(
                                  {params:self.props.urlParams,  
                                    siteID:values.product.s_id, 
                                    identification_GSM:values.product['identification_GSM'],
                                    identificationType:values.product.identification_type, 
                                    p_id:this.props.product.id,
                                    FFNUM_MODE:this.props.product.FFNUM_MODE, 
                                    gsm_dirty:this.props.fields.product.identification_GSM.dirty}))
                          .then(()=>this.setState({gsm_error:false}), (e)=>this.setState({'gsm_error': (e && e.error) ? e.error : (typeof e === 'string' ? e : 'Erreur serveur')}))
                                  
                        })
                      }}
                    />

                  </div>
                   
                  
                  
                </div>
              
                }
            </div>
          }
          
        } else {
          btnFosse = (
            <Button bsStyle="danger" ><i className="fa fa-info-circle" aria-hidden="true"></i> 
             &nbsp; {t("main.sheet_is_pit")}
            </Button>);
          delete productForm.identification.identification_fosse
        }
      
      }
      
    } else if( self.props.action == 'create' ){
      
      var used_mod_nums_master = used_mods.map((m)=>{
        
        return m.identification_NUM_MOD;
        
      });
    }
    
    var disabled_inputs = []
    var disabled_groups = []
    
    if( self.props.action == 'create' ) {
      disabled_groups.push('PIT')
      disabled_inputs.push('identification_fosse', 'PIT');
    }
    
    if( self.props.action == 'update' ) {
      
      // Détecter les actions en cours via modif_champ (etat=0 = en cours)
      // Ces détections persistent après F5 car modif_champ vient de la BDD
      var hasCurrentGSMModif = _.where(product.modif_champ, {action:'modify_gsm', etat:0}).length > 0
      var hasCurrentIDPTUModif = _.where(product.modif_champ, {action:'modify_idptu', etat:0}).length > 0
      var hasCurrentResetSerial = _.where(product.modif_champ, {action:'reset_serial', etat:0}).length > 0
      
      // Détecter les actions FTP en cours via site_state (états 1-2 = en cours)
      var ftpStates = analyseState(state);
      var hasCurrentFTPAction = ftpStates.asts0.state == 1 || ftpStates.asts0.state == 2 ||
                                 ftpStates.asts1.state == 1 || ftpStates.asts1.state == 2 ||
                                 ftpStates.aspr0.state == 1 || ftpStates.aspr0.state == 2 ||
                                 ftpStates.aspr1.state == 1 || ftpStates.aspr1.state == 2
       
      if( is_pit ) {
        disabled_groups = ['localisation', 'PIT', 'caracs', 'groupe']
        
        _.each(productForm, (inputs, group)=>{
          _.each(inputs, (input)=>{
            if( input.name == 'identification_ID' || input.name == 'identification_NUM_MOD' ) {
              
            } else {
              disabled_inputs.push(input.name)
            }
            
          })
        });
      } else {
        disabled_groups = ['PIT']
        disabled_inputs.push('identification_fosse', 'PIT');
        
        /*if( is_master ) {
          disabled_groups = ['PIT']
        }*/
      }
    }
    
    var i = 0;
    _.each(productForm, (inputs, group)=>{
      var pform = [];
      
      var groupLabel = group;
      
      if(groupLabel == 'PIT') {
        groupLabel = t('main.pit')  
      }
      
      _.each(inputs, (input)=>{
        
        var prop = fields.product[input.name];
        var city = fields.product.localisation_ville;
        var cp = fields.product.localisation_CP;
        var place_id = fields.product.place_id;
        var gps = fields.product.localisation_GPS;
        
        
        var datalist = false;
        
        if( input.datalist == 'phones') {
          // Ne pas afficher la liste des téléphones pour ASC-IP (EQUIPSN)
          if( values.product && values.product.identification_type != 'ASC-IP' ) {
            datalist = this.props.phones;
          }
        }
              
        if( input.name == 'identification_NUM_MOD' ){
          var choices = []
          
          var i = is_pit ? 2 : 1;
          for(i; i <= 8; i++){
            if( _.indexOf(used_mod_nums_master, i) == -1 ) {
              choices.push(i)
            } 
          }
          
          input.choices = choices
        }
        
        if(input.asyncUpdate && !disableAsyncUpdate){
        
          var actions = input.asyncUpdate.actions.map((a)=>{
            return a.split('.')
          })          
          
          var cb = {
            type:input.asyncUpdate.type,
            func:()=>{
              
              var allPromises = []              
              
              _.each(actions, (action)=>{
                
                allPromises.push(
                
                  new Promise((resolve, reject)=>{

                      if(fields.product[input.name].dirty == true && fields.product[input.name].invalid == false) {

                        if( action[1] == 'checkIdDups' ){
                          var params = {
                            params:self.props.urlParams, 
                            identification_ID:values.product['identification_ID'], 
                            gsm:values.product['identification_GSM'], 
                            p_id:this.props.action == 'update'?product.id : null, 
                            s_id:this.props.action == 'update'?product.s_id : null,
                            is_pit,
                            idff
                          }
                                                  
                        } else if( action[1] == 'getUsedMods' ) {
      
                          var params = {
                              params:self.props.urlParams, 
                              siteId:values.product.s_id, 
                              identification_GSM:values.product['identification_GSM'], 
                              identificationType:values.product.identification_type,
                              p_id:this.props.action == 'update'?product.id : null,
                              FFNUM_MODE:this.props.product.FFNUM_MODE,
                              gsm_dirty:this.props.fields.product.identification_GSM.dirty
                          }
                          
                        }                                                
                  
                        const actionModule = actionModules[action[0]];
                        if (!actionModule || typeof actionModule[action[1]] !== 'function') {
                          reject(new Error('Unknown async action: ' + action[0] + '.' + action[1]));
                          return;
                        }

                        self.props.dispatch(actionModule[action[1]](params))
                        .then(()=>{                          
                          if(  action[1] == 'getUsedMods' ) {                                                    
                            this.setState({gsm_error:false})                          
                          } else if( action[1] == 'checkIdDups' ){
                          }                          
                          resolve('ok')                          
                         },                         
                          (e)=>{                            
                            if( action[1] == 'getUsedMods' ) {
                              this.setState({'gsm_error': (e && e.error) ? e.error : (typeof e === 'string' ? e : 'Erreur serveur')})
                            } else if( action[1] == 'checkIdDups' ) {                              
                            }
                          })
                      }
                  })
                )
              })                                      
              Promise.all(allPromises)
            }
          } 
          
        } else {
          var cb = null;
        }
        
        var masked = false;
        if( (values.product && values.product.identification_type || '').includes('ASC') ) {
          masked = input.displayFor.indexOf('ASC') < 0
        } else if (values.product.identification_type == 'EM' ) {
          masked = input.displayFor.indexOf('ESC') < 0
        }
                
        if( _.indexOf(disabled_inputs, input.name) == -1 ) {
          
          var disabled2 = false;
          
          try {
            // Désactiver si une action MCP est en cours (etat=0 dans modif_champ)
            var hasAnyActionInProgress = hasCurrentResetSerial || hasCurrentGSMModif || hasCurrentIDPTUModif || hasCurrentFTPAction;
            disabled2 = (self.props.action == 'update' && (hasAnyActionInProgress || mcpCalled)) || (user.role.indexOf('user') > -1 && user.super_user == 0);
          } catch(e) {}
          
          if( input.name == 'identification_GSM' || input.name == 'identification_ID'  || input.name == 'identification_NUM_MOD') {
            // Modifier le label et help pour ASC-IP
            var modifiedInput = Object.assign({}, input);
            if( input.name == 'identification_GSM' && values.product && values.product.identification_type == 'ASC-IP' ) {
              // Utiliser identification_EQUIPSN pour la traduction du label et help
              modifiedInput.translationKey = 'identification_EQUIPSN';
              modifiedInput.placeholder = '61PT00539C-';
              // Convertir en majuscules automatiquement
              var originalOnChange = prop.onChange;
              prop = Object.assign({}, prop, {
                onChange: (e) => {
                  if (e && e.target) {
                    e.target.value = e.target.value.toUpperCase();
                  }
                  originalOnChange(e);
                },
                style: { textTransform: 'uppercase' }
              });
            }
            
            pform.push(generateFicheInputs(prop, modifiedInput, disabled2||input.readOnly, {city, cp, place_id, gps},  datalist, cb, true, false, masked, t))
            if( input.name == 'identification_ID' ) {
              pform.push(id_dup_alert)
            }
            
            if( input.name == 'identification_NUM_MOD' ) {
              pform.push(num_mod_alert)
            }           
          }                               
          else {
            pform.push(generateFicheInputs(prop, input, (user.role.indexOf('user') > -1 && user.super_user == 0)||input.readOnly,  {city, cp, place_id, gps}, datalist, cb, false, false, masked, t))
          }
                    
          var isAscIp = values.product && values.product.identification_type === 'ASC-IP'

          if( ((isAscIp && input.name == 'identification_GSM') || (!isAscIp && input.name == 'identification_NUM_SERIAL'))
              && self.props.action == 'update' && product.identification_NUM_MOD == 1 && values.product &&
              // Pour ASC-IP: afficher seulement si le champ EQUIPSN a été modifié
              (!isAscIp || 
               (fields.product.identification_GSM.dirty == true && !fields.product.identification_GSM.invalid) || 
               hasCurrentGSMModif)
          ) {
          
            pform.push(
              
              <ResetSerialNumber 
                key={'reset-serial-' + this.state.reloadKey}
                params={urlParams}
                state={state}
                urlParams={urlParams} 
                product={product}
                site={values.site}
                gsm={values.product.identification_GSM}
                identificationType={values.product.identification_type}
                t_id={this.props.site.t_id}
                modif_champ={product.modif_champ}
                hasCurrentGSMModif ={hasCurrentGSMModif || mcpCalled ? true : false}
                hasCurrentResetSerial={hasCurrentResetSerial}
                is_master={is_master}
                is_pit={is_pit}
                is_slave={is_slave}
                reloadForm={this.reloadForm}
                triggerError={this.triggerError}
                handleOpenModal={this.handleOpenModal}
              />


            )
          
          }
            
          
          
          if( input.name == 'identification_GSM' && self.props.action == 'update' && ((
              fields.product.identification_GSM.dirty == true 
              && !fields.product.identification_GSM.invalid 
              && is_master_product != false ) || hasCurrentGSMModif) &&
              (this.props.site.etat_FTP == 1 || this.props.site.etat_FTP == 3) && //FTP DESACTIVE
              values.product.identification_type !== 'ASC-IP' // Ne pas afficher pour ASC-IP
              
              
          ) {            
            pform.push(                
              <ModifyPhoneNumber 
                key={'modify-phone-' + this.state.reloadKey}
                params={urlParams}
                state={state}
                urlParams={urlParams}
                product={product}
                site={values.site}
                gsm={values.product.identification_GSM}
                identificationType={values.product.identification_type}
                t_id={this.props.site.t_id}
                modif_champ={product.modif_champ}
                hasCurrentGSMModif ={hasCurrentGSMModif || mcpCalled ? true : false}
                hasCurrentResetSerial={hasCurrentResetSerial}
                is_master={is_master}
                is_pit={is_pit}
                is_slave={is_slave}
                reloadForm={this.reloadForm}
                triggerError={this.triggerError}
                handleOpenModal={this.handleOpenModal}
              />
            )
          }
          
          {/* Bouton Admin pour changer le N° SIM directement */}
          if( input.name == 'identification_GSM' && self.props.action == 'update' && is_master_product) {
            pform.push(
              <AdminChangeGSM
                key="adminChangeGSM"
                siteId={product.s_id}
                urlParams={urlParams}
                reloadForm={this.reloadForm}
              />
            )
          }          
          
          if( input.name == 'identification_ID' && self.props.action == 'update' && ((
              fields.product.identification_ID.dirty == true 
              && !fields.product.identification_ID.invalid 
              && is_master_product != false ) || (hasCurrentIDPTUModif)) &&
              (this.props.site.etat_FTP == 1 || this.props.site.etat_FTP == 3) && this.props.id_dup ==false//FTP DESACTIVE                            
          ) {
            pform.push(                
              <ModifyIDPTU
                params={urlParams}
                state={state}
                urlParams={urlParams}
                product={product}
                site={values.site}
                IDPTU={values.product.identification_ID}
                PIDPTU={product.identification_ID}
                modif_champ={product.modif_champ}
                hasCurrentIDPTUModif={hasCurrentIDPTUModif || mcpCalled ? true : false}
                id_dup={this.props.id_dup}
                reloadForm={this.reloadForm}
                triggerError={this.triggerError}
                handleOpenModal={this.handleOpenModal}
              />
            )
          }
        }
        
      })
      
      
      i++;
 
      if( _.indexOf(disabled_groups, group) == -1 ) {

        tabs.push(
          <Tab eventKey={i} className={"formTab"} title={<span style={{'text-transform':'capitalize'}}>{group}</span>}>          
            <Row style={{/*width:'300px',*/ 'paddingLeft':'15px' }}>
              <Col xs={12} md={5} style={{marginRight:'40px'}}>{pform.slice(0, Math.ceil(pform.length/2)+2)}</Col> 
              <Col xs={12} md={5} style={{marginRight:'40px'}}>{pform.slice(Math.ceil(pform.length/2+1)+1)}</Col>  
            </Row>             
          </Tab>
        ) 
        //ProductformGroups.push(fieldSet);
      }
      
      if( self.props.action == 'update' && group == 'PIT' && !is_pit &&  (values.product && values.product.identification_type || '').includes('ASC') ) {
        
        var fosseDisabled = (product.identification_GSM==null || fields.product.identification_GSM.invalid || values.product['identification_GSM']=='' || !values.product['identification_GSM'])
 
        const tooltipFosseDisabled = (
            <Tooltip id="tooltip">
              <strong>{t("productForm.specify_number")}</strong>
            </Tooltip>
          );
         
         var titleFosse = groupLabel;
         if( fosseDisabled ) {
            titleFosse = <OverlayTrigger placement="right" overlay={tooltipFosseDisabled}><span style={{pointerEvents: 'all'}}>{titleFosse}
            &nbsp;<i className="text-danger glyphicon glyphicon-exclamation-sign" aria-hidden="true"></i>
            </span></OverlayTrigger>
          }

        tabs.push(<Tab eventKey={i} disabled={fosseDisabled} title={titleFosse}><br/>{btnFosse}</Tab>)
      }
       
    }); 
  
    i++

    var options = groups.map((g)=>{ 
      return {"label":g.name, "value":g.id, clearableValue:(user.role != 'user' || user.super_user == 1), disabled:(user.role.indexOf('user') > -1 && user.super_user == 0)} 
    })
    
    var userOptions = users.map((g)=>{ 
      return {"label":g.login, "value":g.id, clearableValue:(user.role != 'user' || user.super_user == 1), disabled:(user.role.indexOf('user') > -1 && user.super_user == 0)} 
    })

    var gsm_invalid     = fields.product.identification_GSM.invalid       || values.product.identification_GSM == ''      || values.product.identification_GSM == null;
    var id_ptu_invalid  = fields.product.identification_ID.invalid        || values.product.identification_ID == ''       || values.product.identification_ID == null;
    var num_asc_invalid = fields.product.identification_NUM_ASC.invalid   || values.product.identification_NUM_ASC == ''  || values.product.identification_NUM_ASC == null;
    var num_mod_invalid = fields.product.identification_NUM_MOD.invalid   || values.product.identification_NUM_MOD == ''  || values.product.identification_NUM_MOD == null;
    var addr_invalid    = fields.product.localisation_adresse.invalid     || values.product.localisation_adresse == ''    || values.product.localisation_adresse == null;
  
    var groupDisabled = false;
    var ftpDisabled = false;

    if(
      gsm_invalid
      || addr_invalid
      || id_ptu_invalid
      || num_mod_invalid
      || num_asc_invalid
      /*fields.product.identification_GSM.invalid == true || hasCurrentGSMModif || mcpCalled || */){
      //groupDisabled = true;
      ftpDisabled = true;
    }

    var createGrpLc = (
      <LinkContainer to={addGrpPath}>
        <span style={{'text-decoration':'underline'}}>
          {t('productForm.create_group_to_asso_site')}
        </span>
      </LinkContainer>
    )                      

    if( ! is_pit ) {
      if( this.props.action == 'update' ) {
        //var levels_counts_arr = []
        //levels_counts_arr.push(<tr><th>Etage</th> <th>Nombre d'ouvertures portes</th></tr>)
        var levels_counts_arr = Object.keys(_.omit(levels_counts, 'move_count')).map(key => {
          return (<div>{key} : {levels_counts[key]} </div>)
        })

        var pieData = Object.keys(_.omit(levels_counts, 'move_count')).map(key =>({
          etage:key,
          value:levels_counts[key]
        }))


        //var table = []
        /*
        if( levels_counts ) { 
          _.each(_.omit(levels_counts, 'move_count'), (level, count)=>{
            levels_counts_arr.push(<tr><td style={{"textAlign":"left"}}>{count}</td> <td style={{"textAlign":"center"}}>{level}</td></tr>) 
          }) 
        } 
         
        
        var table = 
          <table>
            {levels_counts_arr}
          </table>
        */
        var etat_sup = product.etat_supervision ?       <div> {t('productForm.supervision_mode_activated')}</div> : <div> {t('productForm.supervision_mode_deactivated')}</div>
        var etat_tele = product.etat_telesurveillance ? <div> {t('productForm.ts_mode_activated')}         </div> : <div> {t('productForm.ts_mode_deactivated')}</div>
                        
        if( !is_pit && is_master_product != false && (values.product && values.product.identification_type || '').includes('ASC') ) {
          
          tabs.push(
            <Tab eventKey={i} title={'FTP'} disabled={ftpDisabled}>            
                <SiteStatePanel
                  sFields={sFields}
                  pFields={fields.product}
                  site={values.site}
                  siteValues={this.props.site}
                  state={state}
                  urlParams={urlParams}
                  product={product}
                  siteForm={SitesformGroups}
                  reloadForm={this.reloadForm}
                  handleOpenModal={this.handleOpenModal}
                  etat_FTP={this.props.site.etat_FTP}
                  hasCurrentGSMModif={hasCurrentGSMModif}
                  hasCurrentIDPTUModif={hasCurrentIDPTUModif}
                  hasCurrentFTPAction={hasCurrentFTPAction}
                />
            </Tab>)        
        }
        
        tabs.push(
          <Tab eventKey={25} title={t('main.state')}>
            <br/>                        
            <Col xs={12} md={6}>
              {etat_tele}
              {etat_sup}
            </Col>
            <Col xs={12} md={6}>
              {product && product.activations.length > 0 &&
                <div>
                  <b>{t('productForm.mises_services')} : </b>
                  <ul>
                    {product.activations.map((a)=><li>{new Date(a.date_reference * 1000).toLocaleDateString() + ' ' + new Date(a.date_reference * 1000).toLocaleTimeString()}</li>)}
                  </ul>
                </div> 
              } 
            </Col>
            {this.props.forceActivationSuccess &&
              <div className="alert alert-success" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true">
                {t('productForm.forced_activation_success')}
                </span>
                
              </div>
            }
            
            {this.props.forceActivationError &&
              <div className="alert alert-danger" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true">
                  {t('main.error_try_again')} 
                </span> 
                
              </div>
          
            }
              <br/> 
              <Col xs={12} md={8}>
                {this.props.user.role == 'admin' && 
                  <Button bsStyle="primary" onClick={()=>self.props.forceActivation(self.props.site.id, self.props.product.id, self.props.urlParams)}>
                    {t('productForm.force_activation')}
                  </Button>
                }
                  
                &nbsp;
                
                {this.props.user.role == 'admin' && 
                  <Button bsStyle="danger" onClick={()=>self.props.resetState(self.props.site.id, self.props.product.id, self.props.urlParams)}>
                    {t('productForm.reset_state')}
                  </Button> 
                }
              </Col>
            
            <br/>
            {/*
            <Row>
              <h4>Tests cycliques</h4>
              <Col xs={12} md={8}>
                {this.props.user.role == 'admin' && 
                  <Button bsStyle="primary" onClick={
                    ()=>self.props.dispatch(ProductActions.activateCyclical(self.props.product.id, self.props.urlParams))
                  }>
                
                    Activer
                  </Button>
                }
                  
                &nbsp;
                
                {this.props.user.role == 'admin' && 
                  <Button bsStyle="danger" onClick={
                    ()=>self.props.dispatch(ProductActions.removeCyclical(self.props.product.id, self.props.urlParams))
                  }>
                
                    Désactiver
                  </Button> 
                }
              </Col>
            </Row>
            */}
            
          </Tab>
        )                
        i++
         
        var groupDisabled = values.product.identification_NUM_MOD > 1 || (fields.product.identification_GSM.invalid || values.product['identification_GSM']=='' || !values.product['identification_GSM'])        
        
        var titleGroup =  t('productForm.users_and_groups')     
        const tooltipTitle = (
          <Tooltip id="tooltip">
            <strong>              
              {t('productForm.number_on_master_mandatory')}
            </strong>
          </Tooltip>
        );                          
        
        if( groupDisabled ) {
          titleGroup = (
            <OverlayTrigger placement="right" overlay={tooltipTitle}>
              <span style={{pointerEvents: 'all'}}>{titleGroup} 
                &nbsp;<i className="text-danger glyphicon glyphicon-exclamation-sign" aria-hidden="true"></i>
              </span>
            </OverlayTrigger>
          )
        }                      
        
        var titleGroup = tabs.push( <Tab eventKey={i} title={titleGroup}  style={{pointerEvents: 'all'}}disabled={groupDisabled}>
          <div className="col-xs-12 col-md-6">
            <br/>            
            { groups.length == 0 &&
              <div className="form-group">
                <LinkContainer to={addGrpPath}>
                  <Button bsStyle="primary" bsSize="small">
                    <span>{t('productForm.create_group_for_product')}</span>
                  </Button>
                </LinkContainer><br/><br/>
              </div>
              
              
            }
    
            
             
            { users.length > 0 &&
              <div className="form-group">
                <div>{t('productForm.product_users')}</div>
                <Select
                  allowCreate={false}
                  clearable={(user.role != 'user' || user.super_user == 1)}
                  name="form-field-name"
                  options={userOptions}
                  
                  multi={true}
                  {...fields['users']}
                  onBlur={() => fields['users'].onBlur(fields['users'].value)}
                />
            
                {/*<select className="form-control" name="groups" style={{width:'200px', marginLeft:'15px', display:'inline'}} multiple {...fields['groups']}>
                  {groups.map(group => <option key={group.name+group.id} value={group.id}>{group.name}</option>)}
                </select>
                <Button style={{verticalAlign:'top'}} bsSize="xs" bsStyle="primary" onClick={()=>{fields.groups.onChange([])}}>Déselectionner</Button>
                */}
              </div>
            }
            
            
            { groups.length > 0 &&
              <div className="form-group">
                <div>{t('productForm.product_groups')}</div>
                <Select
                  allowCreate={false}
                  clearable={(user.role != 'user' || user.super_user == 1)}
                  name="form-field-name"
                  options={options}
                  multi={true}
                  {...fields['groups']}
                  onBlur={() => fields['groups'].onBlur(fields['groups'].value)}
                />
            
                {/*<select className="form-control" name="groups" style={{width:'200px', marginLeft:'15px', display:'inline'}} multiple {...fields['groups']}>
                  {groups.map(group => <option key={group.name+group.id} value={group.id}>{group.name}</option>)}
                </select>
                <Button style={{verticalAlign:'top'}} bsSize="xs" bsStyle="primary" onClick={()=>{fields.groups.onChange([])}}>Déselectionner</Button>
                */}
              </div>
            }
    
          </div>
        </Tab>)

        var newCalcul = product.allTime.taux//*100//((product.allTime.total - product.allTime.plage) / (product.allTime.total - (/*product.panneTime.plage + */ product.indispoTime.plage)))*100
        var newCalcul2 = product.allTime.taux*100

        let {identification_NUM_ASC} = this.props.product;
        var ouvertures = 0
        
        _.each( _.omit(levels_counts, 'move_count'), (v, k)=>{
          ouvertures += v
        } )

        var color = '#7FFF00';
        if( newCalcul < 70 ) {
          color = '#FF0000	';
        }

        if( this.props.action == 'update' && !basicTabs ) {
          tabs.push(
            <Tab eventKey={888} 
              title={
                <div>           
                  <span>
                    <OverlayTrigger placement="right" overlay={tooltipEditPr}>
                      <i className="fa fa-pencil"/>
                    </OverlayTrigger>                                                      
                  </span>              
                </div>
              }>           
            </Tab>      
          )
        }
        
        
        if( this.props.action == 'update' /*&& (values.product && values.product.identification_type || '').includes('ASC')*/) {

          tabs.push(
          
          <Tab mountOnEnter={true} eventKey={2000} title={<span>&nbsp;<i className="fa fa-line-chart"/>&nbsp;{t('main.bilan')}</span>} key="Bilan">
            <br/>
            <br/>
            <Row > 
              <Col xs={12} md={12} >
                <BilanTable 
                  {...this.props}
                  {...this.refs}
                  timeline={this.timeline}
                  urlParams={urlParams}
                  newCalcul={{newCalcul, newCalcul2}}
                  address={address}
                  ouvertures={ouvertures}
                  begin_date={begin_date}
                  end_date={end_date}
                />
              </Col>
            </Row>
    
            <br/>

              <Row>
                
                <Col xs={12} md={12}  id="BarChart">
                  <br/><br/>
                  <h3 style={{textAlign:'center'}}>
                    {t('productForm.trafic1')}
                  </h3>
                  <LineChart data={lineChartData} begin_date={begin_date} end_date={end_date}/>

                  <div id="PieChart"/>
                  <br/><br/>

                  <Row >

                    <Col xs={12} md={12}>

                      <h3 style={{textAlign:'center'}}>
                        {t('productForm.trafic2')}
                      </h3>
                        
                      <h4 style={{textAlign:'center'}}>
                        {t('productForm.nb_moves')} : {levels_counts.move_count}    
                      </h4>

                      <h4 style={{textAlign:'center'}}>
                        {t('productForm.nb_opening')} :  
                      </h4>
                                          
                      <PieChart data={pieData}/>
        
                    </Col>   
                  </Row>

                  <div id="TimelineChart"/>
                  <br/><br/> 

                  <h3 style={{textAlign:'center'}}>
                    {t('productForm.chronology')}
                  </h3>

                  <TimelineChart 
                    data={this.state.timelineItems2}
                    min={moment(this.state.begin_date)}
                    max={moment(this.state.end_date)}
                    id="tm_chart1"
                    totaux={this.props.product.totaux}
                  />

                  <br/><br/>

                  
                 

                </Col> 

                              
              </Row>
              
              
            
  
        <hr/>
        <br/>

        { product.timeline_rows.length > 0 &&
            
            <div>
             
              
              {(user.role == 'admin' ) &&
                <div>
                  <Row>
                    <Col xs={12} md={12}>
                      <h3>{t('productForm.cyclical_calls')}</h3>
                      <div id="cyclical_graph"></div>
                    </Col>
                  </Row>
                  
                 
                </div>
              }
            
            </div>
            
          }
              
          {/*product.timeline_rows.length == 0 &&
              <div><br/><b>Aucune données à afficher</b></div>
          */}
          </Tab>
          
          )
        }

        // --- Onglet "Test ascenseur" (ASC/ASC-IP + last_notify < 24h) ---
        if (this.props.action == 'update' && (product.identification_type === 'ASC-IP' || product.identification_type === 'ASC') && product.equipsn_last_notify) {
          var lastNotifyDate = new Date(product.equipsn_last_notify);
          var hoursSinceNotify = (new Date() - lastNotifyDate) / (1000 * 60 * 60);
          if (hoursSinceNotify <= 24) {
            tabs.push(
              <Tab mountOnEnter unmountOnExit eventKey={2001} title={<span>&nbsp;<i className="fa fa-arrows-v"/>&nbsp;{t('productForm.test_lift')}</span>} key="TestLift">
                <RemoteTestLift
                  productID={product.id}
                  identificationType={product.identification_type}
                  urlParams={urlParams}
                />
              </Tab>
            )
          }
        }
        
      }
    }

    
          
    {/*
    if( this.props.action == 'update' && is_pit == false && basicTabs ) {
      tabs.push(
        <Tab eventKey={777} title={
           <div            
             onClick={()=>{}}>           
              <span>
                {extra_tabs ? <i style={{cursor:'pointer'}} className="fa fa-minus" aria-hidden="true"></i> : 
                <i className="fa fa-plus" style={{cursor:'pointer'}} aria-hidden="true"></i>}
              </span>              
            </div>
            }>           
        </Tab>      
      )
    }*/}
    
    
    // --- Vue simplifiée mobile : toutes les sections (onglets) restent accessibles ---
    var mobileHubActive = this.props.action == 'update' && !this.state.mobileFull;
    var mobileSections = tabs
      .filter((tab) => tab && tab.props && tab.props.eventKey != 888 && tab.props.eventKey != 777)
      .map((tab) => ({ key: tab.props.eventKey, title: tab.props.title, disabled: !!tab.props.disabled }));
    var ftpSection = _.find(mobileSections, (s) => s.title === 'FTP');
    var mobileStateSummary = null;
    if (this.props.action == 'update') {
      try {
        mobileStateSummary = getStateSummary({ ...product, etat_FTP: this.props.site && this.props.site.etat_FTP, s_etat: state });
      } catch (e) {
        mobileStateSummary = null;
      }
    }
    var mobileTypeLabel = product && (product.identification_type == 'EM' ? t("main.mecanic_stairs")
      : product.identification_type == 'ASC-IP' ? 'Ascenseur CAN-IP'
      : product.identification_type == 'ASC' ? 'Ascenseur' : product.identification_type);
    var mobileTestLiftAvailable = this.props.action == 'update' && (product.identification_type === 'ASC-IP' || product.identification_type === 'ASC')
      && product.equipsn_last_notify && ((new Date() - new Date(product.equipsn_last_notify)) / (1000 * 60 * 60)) <= 24;

    var tabContainer =( <Tabs unmountOnExit mountOnEnter activeKey={this.props.selectedTab} onSelect={this.handleSelect} ref='tabs' >
    
      {basicTabs ? tabs : tabs.slice(-2)}
    
    
    </Tabs>)
    
    if( error ) {
      var errorObj = (
        <Col md={6}>
          <div className="alert alert-danger" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            {error} 
            <Button bsStyle="primary" type="button" onClick={this.reloadFiche}>{t('main.reload_sheet')}</Button>
          </div>
        </Col>);
    } else {
      var errorObj = <span/>;
    }

    

    //var addGrpPath = user.role == 'admin' ? '/admin/groups/'+this.props.urlParams.id+'/create' : '/client/addGroup';
    
    
    
    if( gsm_invalid || id_ptu_invalid || num_asc_invalid || addr_invalid )
    {
      var requiredFieldsWarning = 
        <Row>
          <div className="col-xs-12 col-md-5">
           <Alert bsStyle="warning">
             <i className="fa fa-warning" aria-hidden="true"/> &nbsp;
             {t('main.please_fill')} :
             <ul>
             {gsm_invalid &&
              <li>{t('productForm.gsm_number_onglet')}</li>
             } 
             {id_ptu_invalid &&
              <li>{t('productForm.idptu_onglet')}</li>
             }
             {num_asc_invalid &&
              <li>{t('productForm.num_install_id')}</li>
             }
             {addr_invalid &&
              <li>{t('productForm.address_local_onglet')}</li>
             }
             </ul>
             
    
           </Alert>
          </div>
        </Row>
    
    } else {
      var requiredFieldsWarning = ''
    }
     
    var title;          
    title = t('main.edit_sheet')
    if( is_pit == true ) {
      title = t('main.edit_pit')
    } else if( is_master == true) {
      title = t('main.edit_master_sheet')
    } else if( is_slave != false ) {
      title = t('main.edit_slave_sheet')
    }


    if( !basicTabs ) {
      title = t('productForm.fiche_bilan')
    }
    
    if( this.props.action == 'update' ) {
      var successMessage = <span> {successTitle} </span>
      
    } else if( this.props.action == 'create' ) {
      var successMessage = <span> {t('productForm.sheet_created')}</span>
    }
    
    if( success != false ) {
      var successObj = (
        <Col xs={12} md={6}>
          <div className="alert alert-success" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            {successMessage}
          </div>
        </Col>);
    } else {
      var successObj = <span/>;
    }
    
    var id_ptu_modified  = 
        self.props.action == 'update' && ((
        fields.product.identification_ID.dirty == true 
        && !fields.product.identification_ID.invalid 
        && is_master_product != false )) &&
        (this.props.site.etat_FTP == 1 || this.props.site.etat_FTP == 3)
        
        
   var phone_num_modified = 
          self.props.action == 'update' && ((
          fields.product.identification_GSM.dirty == true 
          && !fields.product.identification_GSM.invalid 
          && is_master_product != false )) &&
          (this.props.site.etat_FTP == 1 || this.props.site.etat_FTP == 3)
    

    const rangeOfYears = (start, end) => Array(end - start + 1)
          .fill(start)
          .map((year, index) => year + index)


    let yList = first_activation_begin_date ? rangeOfYears(first_activation_begin_date.getFullYear(), new Date().getFullYear()) : []
    
    return (
      
      <div  id="editPage">

        {(this.props.action=='update' && this.props.selectedTab == 2000) &&
      
            <Menu styles={ styles }  isOpen={ typeof window === 'undefined' || window.innerWidth > 767 }  right noOverlay>  
              <div>
                <div>

                  <h4><i className="fa fa-line-chart" aria-hidden="true" style={{verticalAlign:'middle'}}></i> 
                    {t('productForm.bilan_menu')} {loading && <i style={{fontSize:'13px'}} className={'fa fa-cog fa-spin'}/>}</h4> <br/>
                  
                  <h5>
                    <b>
                    {t('productForm.filter_by_date')}
                    </b>
                  </h5>

                  <div style={{marginBottom:'5px'}}>
                    {t('main.start')}

                    {/*
                    
                    <select className="form-control" name="groups" style={{width:'80px', height:'28px', marginLeft:'15px', display:'inline'}} onChange={(e)=>{

                      let nb = new Date(begin_date.getTime());

                      nb.setYear(e.target.value)

                      this.setState({begin_date:nb}, ()=>this.filterFunc())

  
                    }}> 
                      {yList.map(y=>
                        <option value={y} selected={parseInt(begin_date.getFullYear())==parseInt(y)}>{y}</option>
                      )}
                    </select> */}
                  </div>
                

                  <Datetime  ref="begin_date_t"  locale={i18next.language}
                    value={begin_date}
                    onChange={begin_date=>{
                      this.setState({begin_date:begin_date.toDate(), filterByDate:''}, ()=>this.filterFunc())
                    }}
                    
                  />

                </div>
              
                <div>

                  <br/>

                  <div style={{marginBottom:'5px'}}>

                    {t('main.end')}

                    {/*
                    
                    <select className="form-control" name="groups" style={{width:'80px', height:'28px', marginLeft:'15px', display:'inline'}} onChange={(e)=>{
              

                      let nb = new Date(end_date.getTime());
                      nb.setYear(e.target.value)

                      this.setState({end_date:nb}, ()=>this.filterFunc())
                    }}>
                      {yList.map(y=>
                        <option value={y} selected={parseInt(end_date.getFullYear())==parseInt(y)}>{y}</option>
                      )}                                  
                    </select>
                      */}

                  </div>

                
                  <Datetime  ref="end_date_t" value={end_date} onChange={end_date=>{
                      this.setState({end_date:end_date.toDate(), filterByDate:''}, ()=>this.filterFunc())
                    }} locale={i18next.language} />
                </div>

                <br/> 


                <div>
                  <button type="button" className="btn btn-primary btn-sm" onClick={()=>{

                    this.filterFunc(true);

                    this.setState({filterByDate:''})

                  }}>{t('productForm.from_date_service')}</button>
                  

                  {/*
                  &nbsp;

                  <button type="button" className="btn btn-danger btn-sm" onClick={()=>{

                    var begin_date2 = new Date()
                    var end_date2  = new Date()

                    begin_date2.setMonth(0)
                    begin_date2.setDate(1)
                
                    begin_date2.setHours(0)
                    begin_date2.setMinutes(1)
                        
                
                    end_date2.setHours(23) 
                    end_date2.setMinutes(59)

                    
                    
                    this.props.loadProduct(urlParams.productID, urlParams, {
                      begin_date:begin_date2, 
                      end_date: end_date2} ).then(()=>{
                        this.setState({
                          begin_date:begin_date2,
                          end_date:end_date2,
                        })
                      //self.props.sortCounts(begin_date_u2, end_date_u2, self.props.urlParams)
                      //this.setState({begin_date, end_date})
                    })
                    
                  }}>Reset</button>

                */}

                  </div>

                  <br/>
                  <div>

                    <div style={{marginBottom:'10px'}}>
                      {t('productForm.filter_by_year')} : 
                    </div>
                    
                  
                    <select 
                      
                      className="form-control" 
                      name="groups" 
                      style={{/*width:'80px',*/ height:'28px', display:'inline'}} 
                      value={this.state.filterByDate} 
                      
                      onChange={(e)=>{                      
                        if(e.target.value == '') {
                          this.setState({filterByDate:''}, ()=>this.filterFunc(true))
                          return
                        }
                        let nb;

                        if( parseInt(this.state.first_activation_begin_date.getFullYear()) == parseInt(e.target.value) ) {
                          nb = this.state.first_activation_begin_date;
                        } else {
                          nb = new Date(begin_date.getTime());
                          nb.setYear(e.target.value)

                          nb.setMonth(0)
                          nb.setDate(1)
        
                          nb.setHours(0)
                          nb.setMinutes(0)
                        }
                        let nb2 = new Date(nb.getTime());

                        nb2.setMonth(11)
                        nb2.setDate(31)
      
                        nb2.setHours(23)
                        nb2.setMinutes(59)

                        this.setState({begin_date:nb, end_date:nb2, filterByDate:nb.getFullYear()}, ()=>this.filterFunc())

                      }}>
                      <option value=""></option>
                      {yList.map(y=>
                        <option value={y}>{y}</option>
                      )}
                    </select>


                  </div>


                  
                  <hr/>

                  <div id="graph_menu_container">

                    <div style={{cursor:'pointer'}} onClick={()=>document.getElementById('editPage').scrollIntoView()}>
                    
                    <i className="fa fa-table" aria-hidden="true" style={{verticalAlign:'middle'}}></i>&nbsp; {t('productForm.bilan_table')}</div> <br/>

                    <div style={{cursor:'pointer'}} onClick={()=>document.getElementById('BarChart').scrollIntoView()}><i className="fa fa-chart-bar"/> 
                    <i className="fa fa-bar-chart" aria-hidden="true"  style={{verticalAlign:'middle'}}></i> {t('productForm.trafic1')}</div> <br/>

                    <div style={{cursor:'pointer'}} onClick={()=>document.getElementById('PieChart').scrollIntoView()}><i className="fa fa-chart-pie"/> 
                    <i className="fa fa-pie-chart" aria-hidden="true" style={{verticalAlign:'middle'}}></i>&nbsp; {t('productForm.trafic2')}</div> <br/>

                    <div style={{cursor:'pointer'}} onClick={()=>document.getElementById('TimelineChart').scrollIntoView()}><i className="fa fa-clock"/> 
                    <i className="fa fa-line-chart" aria-hidden="true" style={{verticalAlign:'middle'}}></i> {t('productForm.chronology')}</div> <br/>

                  </div>
            
              </div>
            </Menu>

      }

        {mobileHubActive &&
          <div className="visible-xs-block">
            <MobileProductHub
              t={t}
              product={product}
              typeLabel={mobileTypeLabel}
              stateSummary={mobileStateSummary}
              warnings={requiredFieldsWarning}
              sections={mobileSections}
              formSectionKey={mobileSections.length > 0 ? mobileSections[0].key : null}
              ftpSectionKey={ftpSection ? ftpSection.key : null}
              testLiftAvailable={mobileTestLiftAvailable}
              onOpenSection={this.openMobileSection}
              onSupervision={() => {
                this.props.dispatch(resetFilter())
                this.props.dispatch(push(supPath))
              }}
              onHelp={this.props.handleOpenModal}
              onFullView={() => this.setMobileFull(true)}
            />
          </div>
        }

        {(this.props.action == 'update' && this.state.mobileFull) &&
          <div className="visible-xs-block mobile-full-bar">
            <Button bsSize="sm" onClick={() => this.setMobileFull(false)}>
              <i className="fa fa-chevron-left" />&nbsp; {t('mobileProduct.simplified_view')}
            </Button>
          </div>
        }

      <div className={mobileHubActive ? 'hidden-xs' : ''}>
        
        {this.props.action == 'update' &&
          <Row>
            
            <Col xs={12}>

            <h1>{title}&nbsp;

              <OverlayTrigger placement="right" overlay={tooltipAide}>
                <Button bsStyle="primary" bsSize="sm" onClick={this.props.handleOpenModal}> 
                <i className="fa fa-question-circle"/> 
                </Button>
              </OverlayTrigger>

              &nbsp;

              <OverlayTrigger placement="right" overlay={tooltipSup}>
                <Button bsSize="sm" bsStyle="primary"  onClick={() => {
                  this.props.dispatch(resetFilter())
                  this.props.dispatch(push(supPath))
                }}> 
                <i className="fa fa-eye" /> 
                </Button>
              </OverlayTrigger>

            </h1> 
            <h4>
              {t('main.install_num')} : {this.props.product.identification_NUM_ASC} {loading && <i className={'fa fa-cog fa-spin'}/>} 
            </h4>
            <br/>
            </Col>
          </Row>
          
        }
    <Row>
      <div className="col-xs-12" style={{'margin-bottom':'10px'}}>
          
        <form id="" className="form-horizontal">          
        
            {(mcpCalled == true || hasCurrentGSMModif || hasCurrentIDPTUModif || hasCurrentResetSerial || hasCurrentFTPAction || from == 'ftpPanel') &&
              <Row> 
                <div className="col-xs-6">
                  <Alert bsStyle="warning">
                    <i className='fa fa-spinner fa-pulse  fa-fw'/> &nbsp;
                    {t('productForm.syncing')}
                    <br/>
                    
                    {(hasCurrentGSMModif || from == 'modifyPhoneNumber') &&
                      <div><b>
                        {t('productForm.modifying_gsm_num')}
                        </b></div>                      
                    }
                    
                    {(hasCurrentResetSerial || from == 'ResetSerialNumber') &&
                      <div><b>
                        {t('productForm.resetting_serial', 'Nouveau GSM en cours...')}
                        </b></div>                      
                    }
                    
                    {(hasCurrentIDPTUModif || from == 'modifyIDPTU') &&
                      <div><b>
                        {t('productForm.modifying_idptu')}
                        </b></div>                      
                    }
                    
                    {(hasCurrentFTPAction || from == 'ftpPanel') &&
                      <div><b>
                        {t('productForm.ftp_action', 'Action FTP en cours...')}
                        </b></div>                      
                    } 
                    
                    
                    {from == 'ResetSerialNumber'&&
                      <div>
                        <b>{t('productForm.new_num_asked')}</b>
                      </div>
                    }
                    
                   </Alert>
                </div>
              </Row>
            }
            
            {is_slave}
            
            {(user.role.indexOf('user') > -1 && user.super_user == 0 ) &&
              <Row>
                <Col xs={5}>
                  <Alert bsStyle="warning">
                    {t('productForm.read_only')}
                  </Alert>
                </Col>
              </Row>
            }
          
          
            {requiredFieldsWarning}
    
            <Row>
              <div className={extra_tabs?"col-xs-12 col-md-11":'col-xs-12 col-md-10'} style={{'margin-bottom':'10px'}}>
                <div className={!is_pit ? "form-group col-xs-12 col-md-12" : "form-group col-xs-12 col-md-7" }>
                  {tabContainer}
                </div> 
              </div>
              
              
              <Row>
                <div className="col-xs-12 col-md-7">
                  {successObj}
                  {/*cascade_num_change*/}
                </div> 
              </Row>
            </Row>
            

            {((user.role != 'user' || user.super_user == 1) && this.props.action == 'update' && ((mandatory_input_changed.length > 0  || invalid) || (idptuError || phoneError)) || this.state.gsm_error ) &&                
              <Row> 
                <Col xs={4}> 
                  <Alert bsStyle="danger">
                    <i className="glyphicon glyphicon-info-sign" aria-hidden="true"/> {t('productForm.you_cant_save')} :
                    <ul>
                      {invalid &&
                        <li>{t('main.errors_in_form')}</li>
                      }
                      
                      {idptuError &&
                        <li>{t('productForm.idptu_invalid')}</li>
                      }
                      
                      {phoneError &&
                        <li>{t('productForm.gsm_num_invalid')}</li>
                      }
                      
                      {/*pristine &&
                        <li>Aucune modification sur le formulaire</li>
                      */}
                    
                      {(_.indexOf(mandatory_input_changed, 'identification_ID') > -1)  &&
                        <li>{t('productForm.idptu_modified')}</li>
                      }
                      
                      {(_.indexOf(mandatory_input_changed, 'identification_GSM') > -1 ) &&
                        <li>{t('productForm.phone_modified')}</li>
                      }
                      
                      {this.state.gsm_error!=false&&
                        <li><span>{this.state.gsm_error||''}</span></li>
                      
                      }
                      
                    
                    </ul>
                  </Alert>
                </Col>
              </Row>
              }
            
            <hr/>
    
            {(this.props.action == 'update' && (user.role != 'user' || user.super_user == 1)) &&
               
              <Row>
                <Col xs={12} md={6}>
                  <button type="button" className="btn btn-success btn-sm"
                    onClick={handleSubmit(() => {
                      
                      if(this.props.action == 'update') {
                        try {
                          values.groups = values.groups.map((g)=>{return g.value})                                                       
                        } catch(e){                             
                        }
                        
                        var nfields = _.pick(fields, 'users', 'site','groups','product')
                        
                        nfields.product = _.pick(nfields.product, 'identification_GSM', 'localisation_adresse')
                        
                        save(values, nfields, this.props.urlParams, this.props.pristineValues, is_pit, is_master, this.props.product.FF )
                          .then(result => {
                            if (result && typeof result.error === 'object') {
                              return Promise.reject(result.error);
                            } else {
                              
                            }
                            this.props.reloadPage() 
                          }).catch(()=>{
                            
                          })
                          
                      } else { 
                                                
                        createProduct( values, fields, this.props.urlParams ).then((vars)=>{
                          self.props.dispatch(ProductActions.clearProducts())
                        }); 
                      } 
                    } 
                    )}
                    disabled={ this.state.gsm_error || phone_num_modified || id_ptu_modified || check_id_dups_loading ||/* this.props.idptuError || this.props.phoneError ||   */
                    pristine || invalid || loading  || (mandatory_input_changed.length > 0 && (self.props.product.etat_en_service==1/*ficheState.aspr1.state == 3 || ficheState.asts1.state == 3*/) && is_master_product != false) || (id_dup && fields.product.identification_ID.dirty) || mcpCalled || hasCurrentGSMModif || hasCurrentIDPTUModif || hasCurrentResetSerial || hasCurrentFTPAction}>
                
                    <i className={'fa ' + (loading ? 'fa-cog fa-spin' : 'fa-cloud')}/> {t('main.save')} {is_pit ? t('productForm.lePIT') : t('productForm.lafiche')}
                  </button>
                      
                    
                   &nbsp;
                   <button type="button" className="btn btn-sm btn-danger"
                      onClick={()=>{
                        self.props.dispatch(reset('productForm'))
                      
                      }}
                    >
                     Reset
                    
                   </button>
                </Col>  

              </Row>
              }
    
              {(this.props.action == 'create' &&  (user.role != 'user' || user.super_user == 1) && ! created)  &&
                <Row>
        
                  <button onClick={handleSubmit(() => {
                      try {
                        values.groups = values.groups.map((g)=>{return g.value})
                      } catch(e){
                        
                      }
                                          
                      createProduct( values, fields, this.props.urlParams ).then((vars)=>{
                        
                        
                        /*var editProductPath = user.role == 'admin' ?
                                '/'+urlParams.role+'/'+urlParams.id+'/product/'+vars.insertId+'/edit' :
                                '/client/product/'+vars.insertId+'/edit';*/
                        
                        var editProductPath;
                        
                        if( user.role == 'admin' ) {
                          editProductPath = '/'+urlParams.role+'/'+urlParams.id+'/product/'+vars.insertId+'/edit'
                        } else if( user.role.indexOf('client') > -1 || user.role == 'demo' ) {
                          editProductPath = '/client/product/'+vars.insertId+'/edit'
                        } else {
                          editProductPath = '/user/product/'+vars.insertId+'/edit'
                        } 
                        
                        setTimeout(function(){ self.props.push(editProductPath); }, 0) 
                      })
                      
                      self.props.dispatch(ProductActions.clearProducts())
                      }
                    )} type="button" className="btn btn-sm btn-success" disabled={created || invalid || loading || id_dup}>
                    <i className={'fa ' + (loading ? 'fa-cog fa-spin' : 'fa-cloud')}/> Créer la fiche
                  </button> 
                    
                  <button type="button" className="btn btn-sm btn-danger"
                    onClick={()=>{
                      self.props.dispatch(reset('productForm'))
                    }}
                  >{t('main.reset')}</button>
    
                </Row> 
              }
                      
              
                
           
            
            <br/>

            <hr/>
            
            <Row>

                <button type="button" className="btn btn-primary btn-sm" onClick={()=>this.props.push(fichesListPath)}>
                  {t('main.return_to_fiches_list')}
                </button>

              {/*
              <Col xs={12}>
                <button type="button" className="btn btn-primary btn-sm" type="button" onClick={()=>this.props.push(fichesListPath)}>
                  Retour à la liste des fiches
                </button>
              </Col>*/}
            </Row> 
            <br/> 

            <ReactModal 
                isOpen={this.state.showModal}
                contentLabel="" style={modalStyles}
                shouldCloseOnOverlayClick={true}
             >
              <div> 
                <div style={{position:'absolute', right:'-1px', top:'-9px', cursor:'pointer'}}> 
                 <i onClick={this.handleCloseModal} className="fa fa-times-circle fa-lg"/>
                </div> 
               
                <p>
                  <br/>
                  {this.state.modalBody}
                </p>
              </div>
              
            </ReactModal>

        </form> 

        </div>

        </Row>
      </div>
     </div>
    );
  } 
}

function generateTimelineItems2( rows, codes, user, t ) {

  var trans = t
  
  var timelineItems = rows.map((t)=>{
    var bg = '#ffafbc';
    if(t.type == 'travaux') {
      bg = 'yellow'
    } else if(t.type == 'indisponible') {
      bg = 'black' 
    } else if(t.type == 'technicien') {
      bg = 'green' 
    } else if(t.type == 'usager') {
      bg = 'orange' 
    }

    if( t.sync ) {
      var sync = 'call_code_sync'+t.sync
    } else {
      var sync = 'call_code_sync9'
    }  

    var start_label = _.where(codes, {[sync]:t.start_code}) 
    var end_label = _.where(codes, {[sync]:t.end_code})
    
    
    if( start_label.length > 0 ) {
      start_label = start_label[0].call_reason
    }
    
    if( end_label.length > 0 ) {
      end_label = end_label[0].call_reason
    }

    //.format('DD-MM-YYYY HH:mm:ss')
    
    var start = new Date(t.start_date *1000)
    var end = t.end_date == null ? new Date(): new Date(t.end_date *1000)
    
    var text = t.end_date == null ? `
      ${moment(start).format('DD/MM/YYYY HH:mm:ss')} : code ${t.start_code} ${start_label}<br/>
      <b style='color:red'>${trans('productForm.produit_tjrs_en_defaut')}</b>` :`

      ${moment(start).format('DD/MM/YYYY HH:mm:ss')} :   Code ${t.start_code} ${start_label}<br/>
     
      ${moment(end).format('DD/MM/YYYY HH:mm:ss')} : Code ${t.end_code} ${end_label}

    
    `
    
    return { 
      start,
      end,
      name:t.type, 
      color:bg,
      text
      
    }
   
  })
  
  return timelineItems
          
}
           
    
    

function generateCyclicalTimelineItems( rows, codes, user ) {
  var i = 0;
    
  var itemsTm = []
  
  var currentItem;  
  var last_code;  
  var currentCode;
  
  
  for (var i = 0; i < rows.length; i++) {
    
    var t = rows[i];    
    var color
    
    
   
    var start_label;
    var end_label;
    
    var style;    
    var sd, ed;
    
    currentCode = t.call_type;
    
    if( currentCode in ['04', 'CO'] ) {
      color = 'green'
    } else {
      color = 'red'
    }
    
    
    if( i == 0 ) {
      currentItem = {
        id:i,
        sd:new Date(t.date_reference * 1000),
        ed:null,
        style:"background:"+color, 
      }
      
      last_code = currentCode;
      
      break;
    }
    
    
    
    
    if(  ['04', 'CO'].indexOf(last_code) > -1 && (currentCode == '04' || currentCode == 'CO') ) {
      //Ne pas créer un autre item
      
    } else if( ['04', 'CO'].indexOf(last_code) > -1 && ( currentCode == '14' || currentCode == 'CK' )) {
      //Créer un autre item rouge
      currentItem['ed'] = new Date(t.date_reference * 1000)
      itemsTm.push(currentItem)
      
      currentItem = {
        id:i,
        sd:new Date(t.date_reference * 1000),
        ed:null,
        style:"background:"+color, 
      }
      
      
      
    } else if( ['14', 'CK'].indexOf(last_code) > -1 && ( currentCode == '14' || currentCode == 'CK' )) {
      
      //Ne pas créer un autre item
      
    }  else if( ['14', 'CK'].indexOf(last_code) > -1 && ( currentCode == '04' || currentCode == 'CO' )) {
      //Créer un autre item
      
      currentItem['ed'] = new Date(t.date_reference * 1000)
      itemsTm.push(currentItem)
      
      currentItem = {
        id:i,
        sd:new Date(t.date_reference * 1000),
        ed:null,
        style:"background:"+color, 
      }
      
    }
    
    
    
    last_code = currentCode;
    
    /*
    if( t.length > 0 ) {
      first_object = t[0];

      sd = new Date(first_object.date_reference*1000)
      
      
      
      if( first_object.call_type == '04' || first_object.call_type == 'CO' ) {
        start_label = first_object.call_type
      } else if(first_object.call_type == 'CK' ) {
        start_label = first_object.call_type
      }
    }
    
    if( t.length > 1 ) {
      second_object = t[1];
      
      
      ed = second_object.date_reference == null ? new Date() : new Date(second_object.date_reference *1000)  
      
      if( second_object.call_type == '04' || second_object.call_type == 'CO' ) {
        end_label = second_object.call_type
        color = 'green'
      } else if( second_object.call_type == '14' || second_object.call_type == 'CK' ) {
        end_label = second_object.call_type
        color = 'red'
      }
      
      
    }
    
    
    if( t.length == 0 ) {
      color = 'red'
    }*/
   
  }
  return new vis.DataSet(itemsTm)   
}

@translate(['common'])
class BilanTable extends React.Component {

  render() {

    let {
      product:{allTime, panneTime, indispoTime, activations, totaux, identification_NUM_ASC, timeline_rows, timeline_rows_per_date}, loadProduct, levels_counts, 
      timeline, urlParams, newCalcul:{newCalcul, newCalcul2}, address, ouvertures, begin_date, end_date, t
    } = this.props


    var maintenances = timeline_rows_per_date.filter(
      
      x=>x.end_code === '64' || x.end_code === '74' 
      /*&& 
      (x.start_date > moment(begin_date).unix() &&  x.start_date < moment(end_date).unix())*/
      
    )

    return (
      <Table striped bordered responsive >
      <thead>
        
        </thead>
        <tbody>
          <tr>
            <th colSpan="4" width="250">
              {t('main.address')} :  {address} <br/>
              {t('productForm.num_lift')} : {identification_NUM_ASC}</th>            
          </tr>
          
          <tr>             
            <th className="td-align-center">{t('main.disponibility')}</th>
            <th className="td-align-center">{t('main.panne')}</th>
            <th className="td-align-center">{t('resume_panel.blocked_users')}</th>
            <th className="td-align-center">{t('main.maintenance')}</th>
          </tr>
        
          <tr>
            <th className="td-align-center">
              
             <OverlayTrigger placement="right" overlay={
               
               <Popover id="tooltip444" style={{width:'600px', maxWidth:'calc(100vw - 20px)'}}>
                 <div >
                   {allTime &&
                     <h3>
                       <b>
                         
                        {t('productForm.dispo_taux')} : 
                         <span className="text-success">&nbsp;
                           {newCalcul2 < 0 ? 0 : newCalcul2 > 100 ?  100 : newCalcul2.toFixed(2) } %
                         </span>
                        </b> 
                     </h3>
                   }
                   
                   {allTime &&                        
                     <h4>{t('productForm.tps_panne_cumule')} : <span className="text-danger"><b>{allTime.plage_date}</b></span> </h4>
                   }
                   
                   {indispoTime &&                        
                     <h4>{t('productForm.tps_indispo_cumule')} : <span className="text-danger"><b>{indispoTime.plage_date} </b></span> </h4>                        
                   }
                                      
                   <p>{t('productForm.taux_calcul')}</p>
                 
                 </div>

               </Popover>
             
             }>
              <div style={{display:'inline-block'}}>
                <GaugeChart percent={newCalcul2}/>
              </div>

              </OverlayTrigger>
              
            </th>
            <th className="td-align-center text-danger" style={{textAlign: 'center', verticalAlign: 'middle', fontSize:'30px'}}>
                <span>
                  {totaux.pannes.total}
                </span>
            </th>

            <th className="td-align-center text-danger" style={{textAlign: 'center', verticalAlign: 'middle', fontSize:'30px'}}> 
              <span>
                {totaux.usagers.total}
              </span>
            </th>
            <th className="td-align-center text-warning" style={{textAlign: 'center', verticalAlign: 'middle', fontSize:'30px'}}>             
              <span>
                {maintenances.length}
              </span>
            </th> 
          </tr>

          <tr>
            <th colSpan='4' style={{padding:0}} >
              <Table striped bordered style={{borderCollapse:'collapse', border:'1px solid black'}}>

                <tbody>
                
                  <tr>
                    <th colSpan="2" className="td-align-center">{t('productForm.trafic')}</th>
                  </tr>
                  
                  <tr>
                    <th className="td-align-center" style={{width:'50%'}}>{t('productForm.deplacements')}</th>
                    <th className="td-align-center" style={{width:'50%'}}>{t('productForm.portes')}</th>                    
                  </tr>

                  <tr>
                    <th className="td-align-center">{levels_counts.move_count}</th>
                    <th className="td-align-center">
                      {ouvertures}
                    </th>                     
                  </tr>
                </tbody>
              </Table>
            </th>                
          </tr>                
        </tbody>
      </Table>      
    )  
  }
}


var styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    right: '10px',
    //top: '30px',
    zIndex:'1000'

  },
  bmBurgerBars: {
    background: '#373a47'
  },
  bmBurgerBarsHover: {
    background: '#a90000'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: '#bdc3c7',outline:'none'
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
    width:"247px",
    outline:'none',
    top:'50px'
    
  },
  bmMenu: {
    background: 'rgb(74, 74, 74)',
    padding: '10px',
    fontSize: '1.10em',
    outline:'none'
  },
  /*bmMorphShape: {
    fill: '#373a47'
  },*/
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em',outline:'none'
  },
  bmItem: {
    display: 'inline-block', outline:'none'
  }
  /*bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)'
  }*/
}
